import "fixed-data-table-2/dist/fixed-data-table.css";
import noFilesImg from "static/to_do_list_nothing.jpg";

import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Table, Column, Cell } from "fixed-data-table-2";
import { TextCell } from "components/FixedDataTableCells";

const formatBytes = bytes => {
  if (!bytes) return "-";
  if (bytes > 1e3 && bytes < 1e6) return `${Math.round(bytes / 1e3)} kB`;
  if (bytes > 1e6 && bytes < 1e9) return `${Math.round(bytes / 1e6)} MB`;
  if (bytes > 1e9 && bytes < 1e12) return `${Math.round(bytes / 1e9)} GB`;
  return `${bytes} B`;
};

const styles = {
  textInputStyle: {
    width: "100%",
    background: "transparent",
    border: "none"
  },
  errorDark: {
    backgroundColor: "hsl(359, 87%, 89%)"
  },
  errorLight: {
    backgroundColor: "hsl(359, 87%, 93%)"
  },
  headerStyle: {
    marginTop: 5,
    fontWeight: "bold"
  },
  tableFont: {
    fontFamily: "Roboto",
    fontSize: "14px"
  },
  map: {
    height: "180px"
  }
};

const getRskCellStyle = (s3Verified, rowIndex) => {
  if (!s3Verified)
    return rowIndex % 2 === 0 ? styles.errorLight : styles.errorDark;
  return {};
};

const getDateCellStyle = (collectionDt, rowIndex) => {
  if (collectionDt === null)
    return rowIndex % 2 === 0 ? styles.errorLight : styles.errorDark;
  return {};
};

const FilesListTable = props => {
  if (!props.filesFetching) {
    if (props.filesList.length === 0) {
      return <img src={noFilesImg} alt="no files to annotate" />;
    }

    return (
      <div style={styles.tableFont}>
        <Table
          rowsCount={props.filesList.length}
          rowHeight={30}
          headerHeight={30}
          // not sure why ContainerDimensions cutting off width, manually edit
          width={props.width - 5}
          height={
            ((props.filesList.length > 10 ? 10 : props.filesList.length) + 1) *
            30
          }
          onRowClick={props.onFilesTableRowSelect}
        >
          <Column
            cell={({ rowIndex, ...colProps }) => {
              const data = props.filesList[rowIndex];
              return (
                <Cell {...colProps}>
                  <input
                    type="checkbox"
                    checked={props.filesBeingAnnotated.includes(data.ctdFilePk)}
                    onChange={() => {}} // Do default row select
                  />
                </Cell>
              );
            }}
            width={40}
          />
          <Column
            header="Survey Date"
            cell={({ rowIndex, ...colProps }) => {
              const date = props.filesList[rowIndex].collectionDt;
              const style = getDateCellStyle(date, rowIndex);
              const dt = date
                ? moment(date).format("ll")
                : "Cast detection failed";
              return (
                <Cell {...colProps} title={moment(date).format()} style={style}>
                  {dt}
                </Cell>
              );
            }}
            width={80}
            flexGrow={1}
          />
          <Column
            header="Filename"
            cell={colProps => (
              <TextCell {...colProps} data={props.filesList} field="filename" />
            )}
            width={280}
            flexGrow={1}
          />
          <Column
            header="Casts"
            cell={colProps => (
              <TextCell {...colProps} data={props.filesList} field="numCasts" />
            )}
            width={20}
            flexGrow={1}
          />
          <Column
            header="File Size"
            cell={({ rowIndex, ...colProps }) => (
              <Cell {...colProps}>
                {formatBytes(props.filesList[rowIndex].fileBytes)}
              </Cell>
            )}
            width={20}
            flexGrow={1}
          />
          <Column
            header="Hex/Rsk uploaded"
            cell={({ rowIndex, ...colProps }) => {
              const { s3Verified } = props.filesList[rowIndex];
              const style = getRskCellStyle(s3Verified, rowIndex);
              return (
                <Cell {...colProps} style={style}>
                  {s3Verified ? "Yes" : "No"}
                </Cell>
              );
            }}
            width={70}
            flexGrow={1}
          />
          <Column
            header="Shutoff"
            cell={colProps => (
              <TextCell {...colProps} data={props.filesList} field="shutoff" />
            )}
            width={20}
            flexGrow={1}
          />
        </Table>
      </div>
    );
  }
  return null;
};

FilesListTable.propTypes = {
  width: PropTypes.number,
  filesFetching: PropTypes.bool.isRequired,
  filesBeingAnnotated: PropTypes.arrayOf(PropTypes.number),
  filesList: PropTypes.arrayOf(
    PropTypes.shape({
      filename: PropTypes.string.isRequired,
      ctdFilePk: PropTypes.number.isRequired,
      numCasts: PropTypes.number,
      shutoff: PropTypes.string,
      fileBytes: PropTypes.number,
      collectionDt: PropTypes.string,
      s3Verified: PropTypes.bool
    })
  ).isRequired,
  onFilesTableRowSelect: PropTypes.func.isRequired
};

FilesListTable.defaultProps = {
  width: 900,
  filesBeingAnnotated: []
};

export default FilesListTable;
